import React from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment/moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { submitDnataExtraForm } from "../../redux/actions/index";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";

const EqualOpportunitiesForm = ({
  appData: { dnataOnboarding, firstName, lastName },
  submitForm,
}) => {
  const typeCode = "YDN6";
  const fullName = `${firstName} ${lastName}`;
  const submitted = dnataOnboarding && dnataOnboarding[typeCode];

  const initialData = {
    name: fullName,
    date: moment().format("DD/MM/YYYY"),
  };

  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: (
        <div>
          <p>
            In accordance with its policy on equal opportunities, Dnata catering
            UK will provide equal opportunities to any employee or job applicant
            and will not discriminate either directly or indirectly because of
            race, sex, sexual orientation, gender reassignment, religion or
            belief, marital or civil partnership status, age, disability, or
            pregnancy and maternity.
          </p>
          <p>
            In order to assess how successful this policy is we have set up a
            system of monitoring all job applications. We would therefore be
            grateful if you would complete the questions on this form. We have
            asked for your name to enable us to monitor applications at
            shortlisting and appointment as well as application stage. However
            the provision of the information in this form is entirely voluntary
            and can be given anonymously if you prefer, by not completing the
            first line.
          </p>
          <p>
            All information will be treated in confidence and will not be seen
            by staff directly involved in the appointment. The questionnaire
            will be detached from your application form, stored separately and
            used only to provide statistics for monitoring purposes. Thank you
            for your assistance.
          </p>
        </div>
      ),
    },
    name: {
      title: "Full Name",
      value: getVal("name"),
    },
    gender: {
      title: "1. Gender",
      value: getVal("gender"),
      type: "radio",
      radioOptions: ["Male", "Female"],
    },
    age: {
      title: "2. Age",
      value: getVal("age"),
    },
    maritalStatus: {
      title: "3. Marital Status",
      value: getVal("maritalStatus"),
      type: "radio",
      radioOptions: [
        "Married (opposite sex)",
        "Married (same sex)",
        "Civil partner",
        "Single",
        "Other",
      ],
    },
    sexOrientation: {
      title: "4. What is your sexual orientation?",
      value: getVal("sexOrientation"),
      type: "radio",
      radioOptions: [
        "Bisexual",
        "Gay man",
        "Gay woman/lesbian",
        "Heterosexual/straight",
        "Other",
        "Prefer not to say",
      ],
    },
    disabilities: {
      title: "5. Do you have any disabilities?",
      value: getVal("disabilities"),
      type: "radio",
      radioOptions: ["Yes", "No"],
    },
    blurb2: {
      htmlObj: (
        <div>
          <p>6. Ethnic origin</p>
          <p>
            (Relates to a sense of identity/belonging on the basis of
            race/culture.)
          </p>
          <p>
            I would describe myself as (choose ONE section from A to E, and then
            tick the appropriate box to indicate your cultural background):
          </p>
        </div>
      ),
    },
    origin: {
      title: "",
      value: getVal("origin"),
      type: "radio",
      radioOptions: [
        "A White:",
        "British",
        "English",
        "Scottish",
        "Welsh",
        "Irish",
        "Other White",
        "B Mixed:",
        "White and Black Caribbean",
        "White and Black African",
        "White and Asian",
        "Other Mixed",
        "C Asian, Asian British, Asian English, Asian Scottish or Asian Welsh:",
        "Indian",
        "Pakistani",
        "Bangladeshi",
        "Other Asian",
        "D Black, Black British, Black English, Black Scottish, or Black Welsh:",
        "Caribbean",
        "African",
        "Other Black",
        "E Chinese, Chinese British, Chinese English, Chinese Scottish, Chinese Welsh, or other ethnic group:",
        "Chinese",
        "Other Chinese",
      ],
    },
    originADependOn: {
      title: "If Other White, please specify",
      value: getVal("originADependOn"),
      dependOn: [{ fieldKey: "origin", allowedValues: ["Other White"] }],
    },
    originBDependOn: {
      title: "If Other Mixed, please specify",
      value: getVal("originBDependOn"),
      dependOn: [{ fieldKey: "origin", allowedValues: ["Other Mixed"] }],
    },
    originCDependOn: {
      title: "If Other Asian, please specify",
      value: getVal("originCDependOn"),
      dependOn: [{ fieldKey: "origin", allowedValues: ["Other Asian"] }],
    },
    originDDependOn: {
      title: "If Other Black, please specify",
      value: getVal("originDDependOn"),
      dependOn: [{ fieldKey: "origin", allowedValues: ["Other Black"] }],
    },
    originEDependOn: {
      title: "If Other Chinese, please specify",
      value: getVal("originEDependOn"),
      dependOn: [{ fieldKey: "origin", allowedValues: ["Other Chinese"] }],
    },
    religion: {
      title: "7. Religious Belief",
      value: getVal("religion"),
      type: "radio",
      radioOptions: [
        "No Religion",
        "Christian",
        "Roman Catholic",
        "Hindu",
        "Sikh",
        "Buddhist",
        "Jewish",
        "Muslim",
        "Any other religion",
        "Prefer not to say",
      ],
    },
    advertised: {
      title: "8. Where did you see this post advertised?",
      value: getVal("advertised"),
    },
    blurb3: {
      htmlObj: (
        <div>
          <p>
            Data protection: Information from this application may be processed
            for purposes registered by the employer under the Data Protection
            Act 1998. Individuals have, on written request [and on payment of a
            fee] the right of access to personal data held about them.
          </p>
          <p>
            I hereby give my consent to Dnata catering UK processing the data
            supplied in this form for the purpose of recruitment and selection.
          </p>
        </div>
      ),
    },
    signature: {
      key: "signature",
      title: "Signature",
      value: getVal("signature"),
    },
    date: {
      key: "date",
      title: "Date",
      value: getVal("date"),
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);

  const redirectBack = () => {
    history.push("/profile/edit/dnata-onboarding");
  };

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    submitForm(typeCode, {
      ...fieldValuesPayload,
    });
    redirectBack();
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Equal Opportunities Form"}
          helper={""}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"dnata"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

EqualOpportunitiesForm.propTypes = {
  appData: any,
  submitForm: func,
};

const mapDispatchToProps = {
  submitForm: submitDnataExtraForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(EqualOpportunitiesForm);
